import { computed, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { SMSCalculator } from '@fasttrack-solutions/sms-calculator';

SMSCalculator.encoding = {
  UTF16: [70, 70, 70],
  GSM_7BIT: [140, 140, 140],
  GSM_7BIT_EX: [140, 140, 140],
};

interface UseSmsStatParams {
  message: Ref<string>;
}

export const useSmsStat = ({ message }: UseSmsStatParams) => {
  const { t } = useI18n();

  const messageStats = computed(() => {
    const { numberOfSMS, remaining } = SMSCalculator.getCount(message.value);
    return t('crm.activities.actions.action_popup.sms_fields.symbols_remaining', {
      numberOfSMS,
      remaining,
    });
  });

  const messageStyle = computed(() => {
    const stats = SMSCalculator.getCount(message.value);
    const isMoreThanOneSms = stats.numberOfSMS > 1;

    return {
      ...(isMoreThanOneSms && {
        color: 'var(--danger-color)',
        'font-weight': 700,
      }),
    };
  });

  return {
    messageStats,
    messageStyle,
  };
};
